import React from 'react';
import { Input, InputNumber, Button, Space, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import moment from 'moment';

// Generic "search this column" text filter dropdown (funnel-icon column search)
export const getTextSearchColumnProps = (dataIndex, placeholder) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <Input
                placeholder={placeholder}
                value={selectedKeys[0]}
                onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                onPressEnter={() => confirm()}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small" style={{ width: 90 }}>
                    Search
                </Button>
                <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </Space>
        </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
    onFilter: (value, record) => (record[dataIndex] || '').toString().toLowerCase().includes(value.toLowerCase())
});

// Numeric min/max range filter dropdown
export const getNumberRangeColumnProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
        const [min, max] = selectedKeys[0] || [];
        return (
            <div style={{ padding: 8, display: 'flex', flexDirection: 'column', gap: 8 }} onKeyDown={(e) => e.stopPropagation()}>
                <InputNumber
                    placeholder="Min"
                    min={0}
                    value={min}
                    onChange={(value) => setSelectedKeys([[value, max]])}
                    style={{ width: 140 }}
                />
                <InputNumber
                    placeholder="Max"
                    min={0}
                    value={max}
                    onChange={(value) => setSelectedKeys([[min, value]])}
                    style={{ width: 140 }}
                />
                <Space>
                    <Button type="primary" onClick={() => confirm()} size="small" style={{ width: 90 }}>
                        Filter
                    </Button>
                    <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                        Reset
                    </Button>
                </Space>
            </div>
        );
    },
    onFilter: (value, record) => {
        const [min, max] = value || [];
        const count = Number(record[dataIndex]) || 0;
        if (min !== undefined && min !== null && count < min) return false;
        if (max !== undefined && max !== null && count > max) return false;
        return true;
    }
});

// Date range filter dropdown
export const getDateRangeColumnProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
            <DatePicker.RangePicker
                value={selectedKeys[0] || null}
                onChange={(dates) => setSelectedKeys(dates ? [dates] : [])}
                style={{ marginBottom: 8, display: 'block' }}
            />
            <Space>
                <Button type="primary" onClick={() => confirm()} size="small" style={{ width: 90 }}>
                    Filter
                </Button>
                <Button onClick={() => { clearFilters(); confirm(); }} size="small" style={{ width: 90 }}>
                    Reset
                </Button>
            </Space>
        </div>
    ),
    onFilter: (value, record) => {
        const [start, end] = value || [];
        if (!start || !end || !record[dataIndex]) return true;
        const date = moment(record[dataIndex]);
        return date.isSameOrAfter(start, 'day') && date.isSameOrBefore(end, 'day');
    }
});
